export const API_URL = "https://web-api.viyume.com/mail/send-mail-flashcard";
export const RECAPTCHA_KEY = "6LfXxYQrAAAAAOMKkHV2cmmkdpBtYPhRWziS7FYH";